<script>
    import Debugger from "../components/functional/Debugger.svelte";

</script>

<Debugger/>